import companyInput from './saveInputs/companyInput';

export default (company) => `
    submitOrg (org: {
        ${companyInput(company)}
    }) {
        id
        name
        fein
    }
`;
